import React, { useEffect, useState } from "react";
import Icons from "../../../../Config/Images";
import "./CustomOrderCard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import TrackOrderComponent from "../TrackOrderComponent";
import {
  getMyOrdersAPI,
  orderTrackingAPI,
} from "../../../../Store/Action/orderAction";
import { removeWishlistAPI } from "../../../../Store/Action/wishlistAction";
import { toast } from "react-toastify";
import DeleteModal from "../../Auth/MyAccount/CustomModals/DeleteModal";
import CheckoutComponent from "../CheckoutComponent";
import OrderItem from "../OrderItem";
import {
  getDisplayStatus,
  getStatusStyles,
} from "../../../../Utils/orderUtils";
import { canCancelOrder } from "../../../../Utils/helper";
import RetryPaymentSummary from "../../Cart/RetryPaymentSummary/RetryPaymentSummary";

const formatDate = (dateString) => {
  if (!dateString) return "";

  let date;

  // Case 1️⃣: If format is DD-MM-YYYY
  if (dateString.includes("-") && dateString.split("-")[0].length === 2) {
    const [day, month, year] = dateString.split("-");
    date = new Date(`${year}-${month}-${day}`);
  }
  // Case 2️⃣: Normal ISO or timestamp
  else {
    date = new Date(dateString);
  }

  const options = { day: "2-digit", month: "short", year: "numeric" };

  return date.toLocaleDateString("en-GB", options);
};

const CustomOrderCard = ({
  order,
  isCollapsed,
  onToggleCollapse,
  activeTab,
  isTrackOrderVisible,
  onGetOrderList,
  fromRewardPoint,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
const location = useLocation();

useEffect(() => {
  if (location.state?.paymentSuccess) {
    toast.success("Payment submitted successfully!");
    // Clear the state so it doesn't re-fire on refresh
    window.history.replaceState({}, "");
  }
}, []);
  const [isModalOpenOrder, setIsModalOpenOrder] = useState(false);
  const [istrackingModalOpen, setIstrackingModalOpen] = useState(false);
  const [orderTracking, setOrderTracking] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [selectedTransactionAmount, setSelectedTransactionAmount] =
    useState(null);
  const [isPaymentBlockedModalOpen, setIsPaymentBlockedModalOpen] =
    useState(false);

  const [isRetrySummaryOpen, setIsRetrySummaryOpen] = useState(false);

  const [isProccessCheckoutModalOpen, setIsProccessCheckoutModalOpen] =
    useState(false);
  // const [statusMap, setStatusMap] = useState({});

  const handleCustomerClick = (order, transactionAmount) => {
    navigate("/payment-card", {
      state: {
        isDuePayment: true,
        orderData: order,
        dueAmount: transactionAmount,
      },
    });
  };

  const handleRetryPaymentClick = () => setIsRetrySummaryOpen(true);

  const isPreOrder = React.useMemo(() => activeTab === "preOrder", [activeTab]);

  const viewInvoice = () => {
    if (order?.invoice_preview_url) {
      window.open(order?.invoice_preview_url, "_blank");
    }
  };

  const handleOpenTracking = () => {
    setIstrackingModalOpen(true);
    dispatch(
      orderTrackingAPI(order?.user_docket_number, (result) => {
        setOrderTracking(result);
      }),
    );
  };

  const handleConfirmDelete = () => {
    const reqData = {
      wishlist_id: order?.wishlist_id,
      flag_deleted: true,
    };

    dispatch(
      removeWishlistAPI(
        reqData,
        (result) => {
          if (result?.status) {
            toast.success(result?.data?.message);
            onGetOrderList();
          }
        },
        true,
      ),
    );
    setIsModalOpenOrder(false);
  };

  const handleOrderedProductClick = (product) => {
    if (!product?.product_name) return;

    const formattedName = product?.product_name
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9\-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");

    navigate(`/productDetail/${formattedName}`, {
      state: { productId: product.product_id },
    });
  };

  const statusLabel = order?.flag_pre_order
    ? "Waiting for in-stock"
    : order?.order_status_name;

  const rawStatus =
    order?.user_docket_result?.data?.at(-1)?.status_name || statusLabel;

  const displayStatus = getDisplayStatus(rawStatus);

  const [variantPopover, setVariantPopover] = useState({
    open: false,
    top: 0,
    left: 0,
    variants: [],
  });

  const handleViewVariants = (event, variants = []) => {
    event.stopPropagation();

    const rect = event.currentTarget.getBoundingClientRect();

    setVariantPopover({
      open: true,
      // top: rect.top + window.scrollY,
      top: rect.bottom + window.scrollY + 8,

      left: rect.left + window.scrollX, // align left of button
      variants,
    });
  };

  return (
    <>
      <div className="my-order-card">
        {/* STATUS HEADER */}
        <div className="shipping-header-div">
          <div className="inner-shipping-header-div">
            <div className="image-status-div">
              <div
                className="status-indicator"
                style={getStatusStyles(
                  order?.user_docket_result?.data?.at(-1)?.status_name ||
                    displayStatus,
                )}
              ></div>
            </div>

            <div className="para-cont-div">
              <p>
                {displayStatus}
                {activeTab === "ongoing" &&
                  order?.estimated_delivery?.estimated_delivery && (
                    <span>
                      &nbsp;(Expected Delivery On{" "}
                      {formatDate(
                        order?.estimated_delivery?.estimated_delivery,
                      )}
                      )
                    </span>
                  )}
              </p>
            </div>
          </div>
          <div className="para-cont-div">
            {order?.transaction_status_name?.toLowerCase() === "failed" && (
              <span className="payment-failed-badge">Payment Failed</span>
            )}
          </div>

          {activeTab === "preOrder" && (
            <div
              className="inner-shipping-header-delete-icon"
              onClick={() => setIsModalOpenOrder(true)}
            >
              <img src={Icons.deleteIcon} alt="" />
            </div>
          )}
        </div>

        {/* DETAILS SECTION */}
        <div className="my-order-card-middle-div">
          <div>
            {activeTab !== "preOrder" && (
              <>
                <div className="order-info">
                  <p>Order Number</p>
                  <span> : {order?.order_number}</span>
                </div>

                <div className="order-info">
                  <p>Product Qty</p>
                  <span> : {order?.product_quantity}</span>
                </div>

                <div className="order-info">
                  <p>Order Placed</p>
                  <span> : {formatDate(order?.order_date)}</span>
                </div>
              </>
            )}

            {isPreOrder && (
              <>
                <div className="order-info">
                  <p>Stamp (Melting)</p>
                  <span>
                    : {order?.product_stamp_value} (
                    {order?.product_melting_value})
                  </span>
                </div>

                <div className="order-info">
                  <p>Wastage</p>
                  <span> : {order?.product_wastage}</span>
                </div>
              </>
            )}
          </div>

          <div>
            <div className="order-info">
              <p>Brand</p>
              <span> : {order?.brand_name}</span>
            </div>

            {isPreOrder && (
              <div className="order-info">
                <p>Pre order Placed</p>
                <span> : {formatDate(order?.order_date)}</span>
              </div>
            )}

            {!isPreOrder && (
              <div className="order-info">
                <p>Order Amount</p>
                <span> : {order?.order_amount}/-</span>
              </div>
            )}
            {!isPreOrder && order?.flag_due_amount ? (
              <>
                <div className="order-info">
                  <p style={{ color: "red" }}>Due Amount</p>
                  <span style={{ color: "red" }}> : {order?.due_amount}</span>
                </div>
              </>
            ) : (
              <> {"\u00A0"}</>
            )}
          </div>

          {/* ACCORDION ICON */}
          <div className="down-vector-img-div">
            <img
              onClick={() => {
                if (!isCollapsed && !orderDetails) {
                  setLoadingDetails(true);
                  // ⭐ PRE-ORDER PANEL DATA
                  if (isPreOrder) {
                    const preOrderProduct = {
                      product_id: order.product_id,
                      product_name: order.product_name,
                      product_image_url: order.product_image?.product_image_url,
                      total_net_weight: order.product_avg_net_weight,
                      total_quantity: order.min_quantity,
                      product_per_pc_rate: order?.product_per_pc_rate,
                      product_category_type_name:
                        order?.product_category_type_name,
                      product_wastage: order?.product_wastage,
                      product_variants: order?.product_variants,
                    };
                    setOrderDetails({
                      order_items: [preOrderProduct],
                    });

                    setLoadingDetails(false);
                    onToggleCollapse();
                    return;
                  }

                  // ⭐ NORMAL ORDER
                  dispatch(
                    getMyOrdersAPI({ order_id: order?.order_id }, (result) => {
                      const orderData = result?.data?.[0];
                      if (orderData) setOrderDetails(orderData);
                      setLoadingDetails(false);
                    }),
                  );
                }

                onToggleCollapse();
              }}
              className={isCollapsed ? "rotate-icon" : ""}
              src={Icons.vectorDownIcon}
              alt=""
            />
          </div>
        </div>

        {/* COLLAPSED CONTENT */}
        {isCollapsed && (
          <>
            <div className="collapsed-content">
              {loadingDetails ? (
                <p
                  style={{
                    textAlign: "center",
                    width: "100%",
                    padding: "10px 0",
                  }}
                >
                  Loading details...
                </p>
              ) : (
                orderDetails?.order_items?.map((item, index) => (
                  <OrderItem
                    key={item?.order_item_id || index}
                    item={item}
                    onProductClick={handleOrderedProductClick}
                    onViewVariants={handleViewVariants}
                    isPreOrder={isPreOrder}
                  />
                ))
              )}
            </div>
            {variantPopover.open && (
              <div
                className="variant-popover"
                style={{
                  top: variantPopover.top,
                  left: variantPopover.left,
                }}
              >
                <div className="variant-popover-header">
                  Variants
                  <span
                    className="variant-close"
                    onClick={() => {
                      setVariantPopover((prev) => ({
                        ...prev,
                        open: false,
                        variants: [],
                      }));
                    }}
                  >
                    ✕
                  </span>
                </div>

                <div className="variant-popover-body">
                  {variantPopover.variants.map((variant, index) => (
                    <div key={index} className="variant-row-order">
                      <p>
                        {/* Net Weight:  */}
                        {variant?.product_net_weight} gm
                      </p>
                      <p>Quantity: {variant?.product_quantity}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {isProccessCheckoutModalOpen && (
              <CheckoutComponent
                onClose={() => setIsProccessCheckoutModalOpen(false)}
                totalAmount={selectedTransactionAmount}
              />
            )}

            {/* ACTION BUTTONS */}
            {!fromRewardPoint && (
              <div className="lower-content-div">
                {!isPreOrder &&
                  order?.order_status_name?.toLowerCase() === "delivered" && (
                    <button
                      onClick={() =>
                        navigate("/my-account/my-orders/write-a-review", {
                          state: {
                            orderData: order,
                            orderItems: orderDetails?.order_items || [],
                          },
                        })
                      }
                    >
                      Write a Review
                    </button>
                  )}

                {order?.invoice_preview_url && (
                  <button onClick={viewInvoice}>View Invoice</button>
                )}

                {activeTab === "ongoing" &&
                  order?.order_status_name?.toLowerCase() === "pending" &&
                  canCancelOrder(order?.order_date) && (
                    <button
                      className="cancel-return-btns"
                      onClick={() =>
                        navigate(
                          `/my-account/my-orders/cancel-order/${order?.order_id}`,
                          { state: { fromCancelBtn: true } },
                        )
                      }
                    >
                      Cancel Order
                    </button>
                  )}
                {/* Make Payment */}
                {activeTab === "ongoing" &&
                  order?.flag_due_amount &&
                  order?.has_pending_transaction && (
                    <button onClick={() => setIsPaymentBlockedModalOpen(true)}>
                      Make Payment
                    </button>
                  )}
                {activeTab === "ongoing" &&
                  order?.flag_due_amount &&
                  !order?.has_pending_transaction && (
                    <button
                      onClick={() =>
                        handleRetryPaymentClick(order, order?.due_amount)
                      }
                    >
                      Retry Payment
                    </button>
                  )}

                {/* Return Order */}
                {/* {activeTab !== "ongoing" &&
                  order?.order_status_name?.toLowerCase() === "delivered" && (
                    <button
                      className="cancel-return-btns"
                      onClick={() =>
                        navigate(
                          `/my-account/my-orders/return-order/${order?.order_id}`,
                          {
                            state: { order: order, fromReturnBtn: true },
                          },
                        )
                      }
                    >
                      Return Order
                    </button>
                  )} */}

                {isTrackOrderVisible &&
                  ["send to the enduser", "shipped"].includes(
                    order?.order_status_name?.toLowerCase(),
                  ) && (
                    <button onClick={handleOpenTracking}>Track Order</button>
                  )}
              </div>
            )}
          </>
        )}

        {istrackingModalOpen && (
          <TrackOrderComponent
            orderData={orderTracking}
            closeThePopUp={() => setIstrackingModalOpen(false)}
          />
        )}
      </div>

      {isModalOpenOrder && (
        <DeleteModal
          onClose={() => setIsModalOpenOrder(false)}
          onDelete={handleConfirmDelete}
        />
      )}
      {isRetrySummaryOpen && (
        <RetryPaymentSummary
          orderId={order?.order_id}
          userId={order?.user_id}
          onClose={() => setIsRetrySummaryOpen(false)}
        />
      )}

      {isPaymentBlockedModalOpen && (
        <div
          className="payment-blocked-overlay"
          onClick={() => setIsPaymentBlockedModalOpen(false)}
        >
          <div
            className="payment-blocked-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="payment-blocked-modal-header">
              <h3></h3>
              <h3>Payment In Progress</h3>
              <span
                className="payment-blocked-close"
                onClick={() => setIsPaymentBlockedModalOpen(false)}
              >
                ✕
              </span>
            </div>
            <div className="payment-blocked-modal-body">
              <p>
                A transaction associated with this order is currently in
                processing status. For security and consistency, additional
                payments cannot be created until the current transaction is
                completed or updated. If you believe this is incorrect or need
                further assistance, please contact the administrator.
              </p>
            </div>
            <div className="payment-blocked-modal-footer">
              <button onClick={() => setIsPaymentBlockedModalOpen(false)}>
                OK, Got it
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomOrderCard;
